<div class="bcg p-4 ">
  <div class="row my-3">
    <div class="col-lg-7 col-sm-7 col-md-7">
      <p class="nav_link_cat ms-1 mb-3 flex_row">
        <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
        <span [style.font-weight]="'bold'"> >> </span>
        <span class="clickable" (click)="gotoListing()">Branch Management</span>
        <span [style.font-weight]="'bold'"> >> </span>
        <span *ngIf="!editMode">Add New branch</span>
        <span *ngIf="editMode">Edit Branch</span>
      </p>
    </div>
  </div>

  <div class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five" *ngIf="!editMode">Add New branch</h5>
          <p class="card-text text_p" *ngIf="!editMode">Create new branch here!</p>
          <h5 class="title_five" *ngIf="editMode">Edit branch</h5>
          <p class="card-text text_p" *ngIf="editMode">Edit branch details here!</p>
        </div>
        <!-- <div *ngIf="!editMode" class="col-lg-6 col-sm-6 col-md-6 text-right">
          <p-button class="ms-2" label="Bulk Upload" styleClass="p-button-sm-outline"></p-button>
        </div> -->
      </div>
    </div>
  </div>
  <div class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row">
        <div *ngIf="!editMode" class="row mt-2 form_inputFields">
          <div class="col-11 m-2">
            <h5 class="title_five">Branch Details</h5>
            <form [formGroup]="addbranchForm">
              <div formArrayName="addnewbranchDetails">
                <section *ngFor="let details of branchDetailsArray().controls; let i=index" [formGroupName]="i">
                  <div class="form_outline_sty">
                    <div class="row">
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Branch Name</span><span class="color_red">*</span>
                        <input class="form-control edit_input" formControlName="name" placeholder="Enter Name"
                          pInputText type="text" (paste)="handlePasteEvent($event)" onkeypress="return (event.charCode >= 65 && event.charCode <= 90)
                          || (event.charCode >= 97 && event.charCode <= 122)
                          || (event.charCode >= 48 && event.charCode <= 57)
                          || event.charCode == 32">
                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && branchDetailsArray().at(i).get('name')?.hasError('required')">*Maximum
                          of 100 characters </span>
                      </div>
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Branch Type</span><span class="color_red">*</span>

                        <div>
                          <app-dropdown [options]="branchType" placeholder="Select Branch Type" optionLabel="name"
                            class="custom-dropdown" optionValue="code" formControlName="type"></app-dropdown>

                        </div>

                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && branchDetailsArray().at(i).get('type')?.hasError('required')">*Maximum
                          of 100 characters </span>
                      </div>
                      <div class="col-lg-3 col-sm-3 col-md-3">
                        <span class="form_field">Organization Name</span><span class="color_red">*</span>
                        <input class="form-control edit_input readOnly grey_background" formControlName="organizationName"
                        [readOnly]="true"  placeholder="Enter Name" pInputText type="text" [(ngModel)]="organisationName">
                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && branchDetailsArray().at(i).get('organizationName')?.hasError('required')">*Maximum
                          of 100 characters </span>
                      </div>
                      <div style="padding-top: 15px;" class="col-lg-1 col-sm-1 col-md-1 remove_btn">
                        <button pButton pRipple type="button" icon="pi pi-trash" (click)="removebranch(i)"
                          class="p-button-sm-outline"></button>
                      </div>

                    </div>
                    <div class="row mt-2">

                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Email</span><span class="color_red">*</span>
                        <input class="form-control edit_input" formControlName="email" placeholder="Enter Email"
                          pInputText type="text">
                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && branchDetailsArray().at(i).get('email')?.hasError('required')">*Enter a
                          Email </span>
                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="branchDetailsArray().at(i).get('email')?.hasError('email')">*Enter a valid Email address</span>
                      </div>
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Contact</span><span class="color_red">*</span>
                        <input class="form-control edit_input" formControlName="contact" placeholder="Enter contact"
                          pInputText type="text" (keypress)="numberOnlyForContact($event)" maxlength="10" minlength="10">
                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && branchDetailsArray().at(i).get('contact')?.hasError('required')">*Enter a
                          contact no. </span>
                          <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="branchDetailsArray().at(i).get('contact')?.hasError('maxlength') || branchDetailsArray().at(i).get('contact')?.hasError('minlength')">*Please enter a valid contact no.
                        </span>
                      </div>
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Pin Code</span><span class="color_red">*</span>
                        <input class="form-control edit_input" formControlName="pinCode" placeholder="Enter pinCode"
                          pInputText type="text" (keypress)="numberOnly($event)" maxlength="6" minlength="6">
                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && (branchDetailsArray().at(i).get('pinCode')?.hasError('required'))">*Pin code is required </span>
                          <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="branchDetailsArray().at(i).get('pinCode')?.hasError('maxlength') || branchDetailsArray().at(i).get('pinCode')?.hasError('minlength')">*Enter a
                          valid PIN </span>
                      </div>
                    </div>
                    <div class="row mt-2">

                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Address</span><span class="color_red">*</span>
                        <input class="form-control edit_input" formControlName="address" placeholder="Enter address"
                          pInputText type="text">
                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && branchDetailsArray().at(i).get('address')?.hasError('required')">*Enter a
                          Address </span>
                      </div>
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Account Name</span><span class="color_red">*</span>
                        <div>
                          <app-dropdown class="custom-dropdown text-left" placeholder='Select Account'
                          [filter]="true"
                          [showClear]="true" filterBy="account_name"
                           (onFilter)="onAccountFilter($event, i)"
                          [options]="filteredAccountDetails[i]" formControlName="accountName" optionLabel="account_name"
                            optionValue="id"></app-dropdown>
                        </div>
                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && branchDetailsArray().at(i).get('accountName')?.hasError('required')">*Enter
                          a Account Name </span>
                      </div>
                      

                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">State Name</span><span class="color_red">*</span>
                        <div>
                          <app-dropdown class="custom-dropdown text-left" placeholder='Select State' [options]="states"
                            formControlName="stateName" optionLabel="state_name" optionValue="id"></app-dropdown>
                        </div>
                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && branchDetailsArray().at(i).get('stateName')?.hasError('required')">*Select
                          a State Name</span>
                      </div>

                    </div>
                    <div class="row mt-2">

                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Status</span><span class="color_red">*</span>
                        <!-- <input class="form-control edit_input" formControlName="status" placeholder="Enter Status" pInputText type="text" value="Active" readonly> -->
                        <input class="form-control edit_input readOnly grey_background" formControlName="status" placeholder="Enter Status"
                          pInputText type="text" [readOnly]="true">

                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && branchDetailsArray().at(i).get('status')?.hasError('required')">*Enter a
                          Status </span>
                      </div>

                    </div>

                  </div>

                </section>

              </div>
              <div class="custom_button me-2 mt-3" style="margin-left: 7px;">
                <p-button icon="pi pi-plus" label="Add Branch" (click)="addNewbranchDetails()"
                  styleClass="p-button-sm-outline"></p-button>
              </div>
            </form>


          </div>
          <div class=" text-right custom_button me-2 mt-3" style="margin-left: 7px;">
            <p-button label="Back"  [style]="{width: '5rem'}" [routerLink]="['/doqfy/management/branch-listing']"
              styleClass="p-button-sm"></p-button>
            <p-button class="ms-2"  [style]="{width: '5rem'}" label="Save" (click)="savebranch()" styleClass="p-button-sm-outline"></p-button>
          </div>
        </div>



        <!----------------  Edit Branch  ------------------------>
        <div *ngIf="editMode" class="row mt-2 form_inputFields">
          <div class="col-12 px-3">
            <h5 class="title_five">Branch Details</h5>
            <form [formGroup]="editbranchForm">
              <div>
                <div class="form_outline_sty">
                  <div class="row g-3">
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Branch Name</span><span class="color_red">*</span>
                      <input class="form-control edit_input" formControlName="name" placeholder="Enter Name" pInputText
                        type="text">
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="submitted && editbranchForm.get('name')?.hasError('required')">*Maximum
                        of 100 characters </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Branch Type</span><span class="color_red">*</span>
                      <div class="overlay">
                        <app-dropdown [options]="branchType" placeholder="Select Branch Type" optionLabel="name"
                          class="custom-dropdown text-left" optionValue="code" formControlName="type"></app-dropdown>
                      </div>
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="submitted && editbranchForm.get('type')?.hasError('required')">*Maximum
                        of 100 characters </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Organization Name</span><span class="color_red">*</span>
                      <input class="form-control edit_input grey_background" formControlName="organizationName" placeholder="Enter Name"
                       [readOnly]="true" pInputText type="text">
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="submitted && editbranchForm.get('organizationName')?.hasError('required')">*Maximum
                        of 100 characters </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Email</span><span class="color_red">*</span>
                      <input class="form-control edit_input" formControlName="email" placeholder="Enter Email"
                        pInputText type="text">
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="submitted && editbranchForm.get('email')?.hasError('required')">*Enter a Email </span>
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="editbranchForm.get('email')?.hasError('email')">*Enter a valid Email address</span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Contact</span><span class="color_red">*</span>
                      <input class="form-control edit_input" formControlName="contact" placeholder="Enter contact"
                        pInputText type="text" (keypress)="numberOnlyForContact($event)" maxlength="10" minlength="10">
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="submitted && editbranchForm.get('contact')?.hasError('required')">*Enter a contact no.
                      </span>
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="editbranchForm.get('contact')?.hasError('maxlength') || editbranchForm.get('contact')?.hasError('minlength')">*Please enter a valid contact no.
                      </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Pin Code</span><span class="color_red">*</span>
                      <input class="form-control edit_input" formControlName="pinCode" placeholder="Enter pinCode"
                        pInputText type="text" (keypress)="numberOnly($event)" maxlength="6" minlength="6">
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="submitted && (editbranchForm.get('pinCode')?.hasError('required'))">*Pin code is required
                      </span>
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="editbranchForm.get('pinCode')?.hasError('maxlength') || editbranchForm.get('pinCode')?.hasError('minlength')">*Enter a valid PIN
                      </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Address</span><span class="color_red">*</span>
                      <input class="form-control edit_input" formControlName="address" placeholder="Enter address"
                        pInputText type="text">
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="submitted && editbranchForm.get('address')?.hasError('required')">*Enter a Address
                      </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Account Name</span><span class="color_red">*</span>
                      <input class="form-control edit_input grey_background" formControlName="accountName" readonly="true" pInputText [(ngModel)]="accountNameDetails"
                        type="text">
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="submitted && editbranchForm.get('accountName')?.hasError('required')">*Maximum
                        of 100 characters </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">State Name</span><span class="color_red">*</span>
                      <div class="overlay">
                        <app-dropdown class="custom-dropdown text-left" placeholder='Select State' [options]="states"
                          formControlName="stateName" optionLabel="state_name" optionValue="id"></app-dropdown>
                      </div>
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="submitted && editbranchForm.get('stateName')?.hasError('required')">*Select a State Name
                      </span>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Status</span><span class="color_red">*</span>
                      <input class="form-control edit_input grey_background" formControlName="status" placeholder="Enter Status"
                        [readOnly]="true" pInputText type="text">
                      <span class="p-error" style="font-size: 0.5rem;"
                        *ngIf="submitted && editbranchForm.get('status')?.hasError('required')">*Enter a Status </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="text-right custom_button px-3 mt-3">
            <p-button label="Back" [style]="{width: '5rem'}" [routerLink]="['/doqfy/management/branch-listing']"
              styleClass="p-button-sm"></p-button>
            <p-button class="ms-2" [style]="{width: '5rem'}" label="Save" (click)="editbranch()" styleClass="p-button-sm-outline"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="toast_display_layer">
  <p-toast></p-toast>
</div>